import { GetStaticPropsContext } from 'next'
import Head from 'next/head'
import { PageStoryblok } from 'storyblok'
import { StoryblokStory } from 'storyblok-generate-ts'
import { Layout } from '~/components/Layout'
import { Page, fetchPage } from '~/features/pages'

type Props = {
  story: StoryblokStory<PageStoryblok>
}

export default function DynamicPage({ story }: Props) {
  return (
    <Layout>
      <Head>
        <meta property="og:url" content={`https://digital.next-step.li/`} />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="12. Berufs- & Bildungstage 2026 | 25./26. September 2026 | Next-Step – Bildung. Beruf. Liechtenstein"
        />
        <meta property="og:image" content="https://digital.next-step.li/share.jpg" />
      </Head>
      <Page story={story} />
    </Layout>
  )
}

export async function getStaticProps({ params, preview = true }: GetStaticPropsContext) {
  const slug = params?.slug ? String(params.slug) : ''
  const page = await fetchPage(slug, preview)

  if (!page) {
    return {
      notFound: true,
    }
  }

  return {
    props: { story: page },
  }
}

// TODO: Fetch all published pages, see https://github.com/storyblok/react-next-boilerplate/blob/main/pages/%5B...slug%5D.js#L57
export async function getStaticPaths() {
  return {
    paths: [{ params: { slug: 'impressum' } }, { params: { slug: 'datenschutz' } }],
    fallback: 'blocking',
  }
}
